import { render } from "./CartOrder.vue?vue&type=template&id=b36bb786"
import script from "./CartOrder.vue?vue&type=script&lang=js"
export * from "./CartOrder.vue?vue&type=script&lang=js"

import "./CartOrder.vue?vue&type=style&index=0&id=b36bb786&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__